exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swiper-container{width:320px;height:320px;padding:40px}.swiper-slide{background-position:50%;background-size:cover;width:100%}.audio-funny-img-pack{object-fit:cover;height:240px;width:240px;margin:0 40px 0 0;display:flex;align-items:center}.audio-controls-funny-pack{float:left;z-index:1;width:240px;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a70b01be","scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/previews/AudioResources.vue
// module id = 410
// module chunks = 1